import request from '@/utils/request'


// 查询海报列表
export function listPoster(query) {
  return request({
    url: '/user/poster/list',
    method: 'get',
    params: query
  })
}

// 查询海报分页
export function pagePoster(query) {
  return request({
    url: '/user/poster/page',
    method: 'get',
    params: query
  })
}

// 查询海报详细
export function getPoster(data) {
  return request({
    url: '/user/poster/detail',
    method: 'get',
    params: data
  })
}

// 新增海报
export function addPoster(data) {
  return request({
    url: '/user/poster/add',
    method: 'post',
    data: data
  })
}

// 修改海报
export function updatePoster(data) {
  return request({
    url: '/user/poster/edit',
    method: 'post',
    data: data
  })
}

// 删除海报
export function delPoster(data) {
  return request({
    url: '/user/poster/delete',
    method: 'post',
    data: data
  })
}
